export default __webpack_public_path__ + "static/media/Sharib.1beac661.png";